import { BaseCategoryFragment, CategoryRuleFragment, fromApiDate } from "@/graphql";
import { mapToTournamentCategory } from "@/mappers/tournament.mappers";
import { BaseCategory, CategoryGender, CategoryRule } from "@/types/category.types";

export const mapToBaseCategory = (fragment: BaseCategoryFragment): BaseCategory => ({
  id: fragment.id,
  name: fragment.name ?? null,
  type: fragment.type ?? null,
  gender: fragment.gender ? mapToCategoryGender(fragment.gender) : null,
  uniqueCode: fragment.uniqueCode ?? null,
  maxTournaments: fragment.maxTournaments ?? null,
  activeFrom: fragment.activeFrom ? fromApiDate(fragment.activeFrom) : null,
  activeTo: fragment.activeTo ? fromApiDate(fragment.activeTo) : null,
  sort: fragment.sort ?? null,
  ageLimit: fragment.ageLimit ?? null,
  ageLimitType: fragment.ageLimitType ?? null,
  selectStage: fragment.selectStage ?? null,
  countries: fragment.countries ?? null,
  timePeriod: fragment.timePeriod ?? null,
  countAllTournament: fragment.countAllTournament ?? false,
  isTeamRanking: fragment.isTeamRanking ?? false,
});

export const mapToCategoryRule = (fragment: CategoryRuleFragment): CategoryRule => ({
  id: fragment.id,
  sector: fragment.sector ?? null,
  tournamentCategories: fragment.tournamentCategories?.map(mapToTournamentCategory) ?? [],
});

export const mapToCategoryGender = (gender: string): CategoryGender => {
  switch (gender.toLowerCase()) {
    case "male":
      return "male";
    case "female":
      return "female";
    case "anyone":
      return "anyone";
    case "mixed":
      return "anyone";
    default:
      throw new Error(`Unexpected category gender: "${gender}"`);
  }
};
